import axios from "axios";
import React, { useCallback, useRef, useState } from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { MenuItem } from "react-contextmenu";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useUserRights } from "../../../contexts/UserRightsContext";
import { contextualFormatter } from "../../fomatters/ContextualFormatter";
import { dateFormatter } from "../../fomatters/DateFormatter";
import Crud from "../Crud";

function AgentsOnline() {
  const crudRef = useRef(null);
  const history = useHistory();

  const [refreshInterval, setRefreshInterval] = useState(5);

  const { data: rights } = useUserRights();

  const hasRights = useCallback(
    (...ids) => ids.some((id) => rights?.includes(id)),
    [rights]
  );

  const handleIntervalChange = (e) => {
    setRefreshInterval(e.target.value);
  };

  const handleMenuClick = (e, data) => {
    const row = data.row;

    switch (data.item) {
      case "Refresh":
        crudRef.current?.requestData();
        break;

      case "Release All":
        ReleaseAll();
        break;

      case "Release":
        Release(row);
        break;

      case "Info":
        Info(row);
        break;

      default:
        break;
    }
  };

  const ReleaseAll = () => {
    const url = `${process.env.REACT_APP_API2_URL}/Agent/AgentsOnline_DeleteAll`;

    axios
      .get(url)
      .then(() => {
        toast.success("Released");

        crudRef.current?.requestData();

        setTimeout(() => {
          crudRef.current?.requestData();
        }, 200);
      })
      .catch((error) => {
        toast.error("Error");
        console.error("Error releasing agents:", error);
      });
  };

  const Release = (row) => {
    if (!row) return;

    const url = `${process.env.REACT_APP_API2_URL}/Agent/AgentsOnline_Delete?idAgentLogons=${row.idAgentLogons}`;

    axios
      .get(url)
      .then(() => {
        toast.success("Released");

        crudRef.current?.requestData();

        setTimeout(() => {
          crudRef.current?.requestData();
        }, 200);
      })
      .catch((error) => {
        toast.error("Error");
        console.error("Error releasing agent:", error);
      });
  };

  const Info = (row) => {
    if (!row) return;

    history.push(`/agentContainer/${row.idAgent}`);
  };

  const renderMenu = (row) => (
    <>
      <MenuItem data={{ item: "Info", row }} onClick={handleMenuClick}>
        Agent Info
      </MenuItem>

      <MenuItem
        disabled={!hasRights(545)}
        data={{ item: "Release", row }}
        onClick={handleMenuClick}
      >
        Release
      </MenuItem>

      <MenuItem
        disabled={!hasRights(476)}
        data={{ item: "Release All", row }}
        onClick={handleMenuClick}
      >
        Release All
      </MenuItem>

      <MenuItem data={{ item: "Refresh", row }} onClick={handleMenuClick}>
        Refresh
      </MenuItem>
    </>
  );

  return (
    <div className="flex flex-col gap-4 h-max">
      <Crud
        ref={crudRef}
        interval={refreshInterval * 1000}
        title="Agents Online"
        getUrl={({ userId }) =>
          `/Agent/AgentsOnline_List?idUser=${userId}`
        }
      >
        <TableHeaderColumn hidden isKey dataField="idAgentLogons">
          IdAgentLogons
        </TableHeaderColumn>

        <TableHeaderColumn hidden dataField="idAgent">
          IdAgent
        </TableHeaderColumn>

        <TableHeaderColumn
          filter={{ type: "TextFilter", delay: 1000 }}
          dataField="agent"
          dataSort
          dataFormat={(cell, row) =>
            contextualFormatter(cell, row, "idAgentLogons", renderMenu)
          }
        >
          Agent
        </TableHeaderColumn>

        <TableHeaderColumn dataField="ip" dataSort>
          IP
        </TableHeaderColumn>

        <TableHeaderColumn
          dataField="placedDate"
          dataFormat={dateFormatter}
          dataSort
        >
          Login Time
        </TableHeaderColumn>
      </Crud>

      <div className="flex items-center gap-2">
        <label>Refresh every:</label>

        <input
          type="number"
          value={refreshInterval}
          onChange={handleIntervalChange}
          className="p-1 border rounded"
          min="1"
        />

        <span>seconds</span>
      </div>
    </div>
  );
}

export default AgentsOnline;